import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Button, Icon } from '@resy/ui-kitchen';

const noop = () => {};

const VenueTypeSearchPill = ({
  icon,
  iconName,
  label,
  isActive,
  onClick,
}) => (
  <Button
    variant="no-style"
    className={cx('SearchVenueTypePills__option', {
      'SearchVenueTypePills__option--active': isActive,
    })}
    aria-label={label}
    onClick={onClick}
  >
    <span className="SearchVenueTypePills__icon">
      <Icon component={icon} name={iconName} width="20px" height="20px" />
    </span>
    <span className="SearchVenueTypePills__label">{label}</span>
  </Button>
);

VenueTypeSearchPill.propTypes = {
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  iconName: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
};

VenueTypeSearchPill.defaultProps = {
  isActive: false,
  onClick: noop,
};

export default VenueTypeSearchPill;
